export default __webpack_public_path__ + "static/media/check.c9675a83.svg";